;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import IconButton from "@mui/material/IconButton"
import SvgIcon from "@mui/material/SvgIcon"
import styles from "./styles.module.scss"
import LeftArrowRoundedCorners from "../icons/LeftArrowRoundedCorners.svg"
import { styled } from "@mui/material/styles"

import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  UI_STYLE_BLACK_COLOR_BUTTON,
  UI_STYLE_BLACK_COLOR_BUTTON_PUSHED,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../lib/constants"

const YellowArrowIconButton = styled(IconButton)(({ theme }) => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON,
  boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25);",

  zIndex: 3,
  outline: 0,
  cursor: "pointer",
  touchAction: "manipulation",
  // position: "absolute",
  // top: "50%",
  transform: "translateY(-50%)",
  border: 0,
  width: "50px",
  height: "50px",
  justifyContent: "center",
  alignItems: "center",
  fill: "#1bcacd",
  padding: 0,

  "@media only screen and (min-width: 600px)": {
    width: "55px",
    height: "55px",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  },
}))

export const NextButton = ({
  enabled,
  onClick,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
}) => (
  <YellowArrowIconButton
    // className={`${styles["embla__button"]} ${styles["embla__button--prev"]}`}
    onClick={onClick}
    disabled={!enabled}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <SvgIcon
      component={LeftArrowRoundedCorners}
      viewBox="0 0 20 34"
      sx={{
        color: UI_STYLE_PRIMARY_BLUE_BLACK,
        "@media only screen and (min-width: 600px)": {
          width: "20px",
          height: "34px",
        },
        width: "30px",
        height: "34px",
        WebkitTransform: "rotate(180deg)",
        transform: "rotate(180deg)",
      }}
    />
  </YellowArrowIconButton>
)

export const PrevButton = ({
  enabled,
  onClick,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
}) => (
  <YellowArrowIconButton
    // className={`${styles["embla__button"]} ${styles["embla__button--next"]}`}
    onClick={onClick}
    disabled={!enabled}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <SvgIcon
      component={LeftArrowRoundedCorners}
      viewBox="0 0 20 34"
      sx={{
        color: UI_STYLE_PRIMARY_BLUE_BLACK,
        "@media only screen and (min-width: 600px)": {
          width: "20px",
          height: "34px",
        },
        width: "30px",
        height: "34px",
      }}
    />
  </YellowArrowIconButton>
)
